import { UserDetailsState } from "@users/models/user-details.state";
import { createReducer, on } from "@ngrx/store";
import * as UserDetailsActions from "@users/store/actions/user-details.actions";

export const initialState: UserDetailsState = {
  user: null,
  loading: false,
  loaded: false
};

export const reducer = createReducer(
  initialState,
  on(UserDetailsActions.loadUserDetails, (state): UserDetailsState => ({
    ...state,
    loading: true,
    loaded: false
  })),
  on(UserDetailsActions.loadUserDetailsSuccess, (state, { userDetails }): UserDetailsState => ({
    ...state,
    user: userDetails,
    loading: false,
    loaded: true
  })),
  on(UserDetailsActions.loadUserDetailsFailure, (state): UserDetailsState => ({
    ...state,
    loading: false,
    loaded: false
  })),
  on(UserDetailsActions.loadUserDetailsNotFound, (state): UserDetailsState => ({
    ...state,
    user: null,
    loading: false,
    loaded: true
  })),
  on(UserDetailsActions.deleteUserDetails, (state): UserDetailsState => ({
    ...state,
    loading: true
  })),
  on(UserDetailsActions.deleteUserDetailsSuccess, (state): UserDetailsState => ({
    ...state,
    user: null,
    loading: false,
    loaded: true
  })),
  on(UserDetailsActions.deleteUserDetailsFailure, (state): UserDetailsState => ({
    ...state,
    loading: false
  })),
  on(UserDetailsActions.enableUser, (state): UserDetailsState => ({
    ...state,
    loading: true
  })),
  on(UserDetailsActions.enableUserSuccess, (state): UserDetailsState => ({
    ...state,
    user: state.user ? { ...state.user, enabled: true } : null,
    loading: false
  })),
  on(UserDetailsActions.enableUserFailure, (state): UserDetailsState => ({
    ...state,
    loading: false
  })),
  on(UserDetailsActions.disableUser, (state): UserDetailsState => ({
    ...state,
    loading: true
  })),
  on(UserDetailsActions.disableUserSuccess, (state): UserDetailsState => ({
    ...state,
    user: state.user ? { ...state.user, enabled: false } : null,
    loading: false
  })),
  on(UserDetailsActions.disableUserFailure, (state): UserDetailsState => ({
    ...state,
    loading: false
  })),
  on(UserDetailsActions.resetAppCode, (state): UserDetailsState => ({
    ...state,
    loading: true
  })),
  on(UserDetailsActions.resetAppCodeSuccess, (state): UserDetailsState => ({
    ...state,
    user: state.user ? { ...state.user, totpEnabled: false } : null,
    loading: false
  })),
  on(UserDetailsActions.resetAppCodeFailure, (state): UserDetailsState => ({
    ...state,
    loading: false
  })),
  on(UserDetailsActions.resetWebauthn, (state): UserDetailsState => ({
    ...state,
    loading: true
  })),
  on(UserDetailsActions.resetWebauthnSuccess, (state): UserDetailsState => ({
    ...state,
    user: state.user ? { ...state.user, webauthnEnabled: false } : null,
    loading: false
  })),
  on(UserDetailsActions.resetWebauthnFailure, (state): UserDetailsState => ({
    ...state,
    loading: false
  }))
);
